import { lazy } from '@loadable/component';
import { createFileRoute } from '@tanstack/react-router';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { MewsTeam, RouteType } from '@mews/enums';

const LazyBILayout = lazy(async () =>
    import(
        /* webpackChunkName: "businessIntelligence" */ '@mews-commander/business-intelligence/components/BILayout'
    ).then((module) => ({
        default: module.BILayout,
    }))
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/BusinessIntelligence')({
    beforeLoad: ({ context: { checkFeatureFlag, checkPrivilege } }) => {
        checkFeatureFlag(FeatureFlag.insightsEnabled);
        checkPrivilege('viewSensitiveReports');
    },
    component: () => <LazyBILayout />,
    staticData: {
        owner: MewsTeam.Analytics,
        title: TextKey.MewsBusinessIntelligence,
        type: RouteType.Frontend,
    },
});
